import React from 'react';
import PropTypes from 'prop-types';

import './SrLoadingSpinner.less';

const SrLoadingSpinner = ({ width, height }) => (
  <img
    styleName='SrLoadingSpinner'
    alt='loading spinner'
    src='/images/loading-spinner-white.svg'
    width={width}
    height={height}
  />
);

SrLoadingSpinner.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

SrLoadingSpinner.defaultProps = {
  width: 'auto',
  height: 'auto',
};

SrLoadingSpinner.displayName = 'SrLoadingSpinner';

export default SrLoadingSpinner;
